/* External dependencies */
import { Div, Dropdown, Text } from 'atomize';
import React from 'react';
import { useState } from 'react';

/* Local dependencies */
import DropdownItems from '../../custom-dropdown/DropdownItems';
import { Specification } from '../../goods-specifications/createConsigneeGoodsSpecifications/redux/types';
import './custom-dropdown.scss';

export interface CustomDropdownProps {
  value: string;
  menuList: Specification[];
  onSelect: (item: Specification) => void;
}

export function CustomDropdown(props: CustomDropdownProps) {
  const { value, menuList, onSelect } = props;

  const [isOpen, setIsOpen] = useState(false);

  function onToggle() {
    setIsOpen((prev) => !prev);
  }

  function onSelectItem(item: Specification) {
    onSelect(item);
    onToggle();
  }

  return (
    <Div rounded="6px" className="custom-dropdown" minW="150px">
      <Dropdown
        m="0"
        p="3px"
        h="auto"
        border="none"
        justify="center"
        isOpen={isOpen}
        style={{ backgroundColor: '#3366FF' }}
        menu={
          <DropdownItems
            items={menuList}
            onClick={(item) => onSelectItem(item)}
          />
        }
        onClick={onToggle}
        data-testid="custom-dropdown"
      >
        <Text
          textColor="white"
          textAlign="center"
          textSize="14px"
          style={{ whiteSpace: 'pre' }}
        >
          {value}
        </Text>
      </Dropdown>
    </Div>
  );
}
